import React from 'react';

function updateRect(element, setRect) {
  const {
    top, right, bottom, left, width, height, x, y,
  } = element.getBoundingClientRect();

  setRect({
    top: top + window.document.documentElement.scrollTop,
    right,
    bottom,
    left,
    width,
    height,
    x,
    y,
  });
}
export default (element) => {
  const [rect, setRect] = React.useState({});

  React.useLayoutEffect(() => {
    if (element) updateRect(element, setRect);
  }, [element, setRect]);

  React.useLayoutEffect(() => {
    const handler = window.addEventListener('resize', () => {
      updateRect(element, setRect);
    });
    return () => {
      window.removeEventListener('resize', handler);
    };
  }, [element]);

  return rect;
};
